var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 134 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49595 11.5207L6.49595 5.71831C6.49595 4.95594 6.83384 4.31608 7.19812 3.8004C4.9396 3.97634 3.2958 5.81459 3.31362 8.04221L3.31362 12.0877C3.31362 13.5195 4.26853 14.5084 4.97603 15.2789L6.49595 16.8623L6.49595 11.5197L6.49595 11.5207Z",
    fill: "url(#paint0_linear_396_228)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9871 6.97311L22.7938 6.97311C23.5567 6.97311 24.197 7.31075 24.7131 7.67476C24.537 5.4179 22.6974 3.7753 20.4682 3.79311L16.4197 3.79311C14.9869 3.79311 13.9973 4.74733 13.2262 5.4543L11.6416 6.97311L16.9882 6.97311H16.9871Z",
    fill: "url(#paint1_linear_396_228)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5343 17.4295L21.5343 23.2319C21.5343 23.9943 21.1964 24.6341 20.8322 25.1498C23.0907 24.9739 24.7345 23.1356 24.7167 20.908L24.7167 16.8625C24.7167 15.4307 23.7617 14.4418 23.0542 13.6713L21.5343 12.0879L21.5343 17.4305L21.5343 17.4295Z",
    fill: "url(#paint2_linear_396_228)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.051 21.9849L5.24432 21.9849C4.4814 21.9849 3.84107 21.6473 3.32501 21.2832C3.50108 23.5401 5.34068 25.1827 7.56993 25.1649L11.6184 25.1649C13.0512 25.1649 14.0408 24.2107 14.8119 23.5037L16.3965 21.9849L11.0499 21.9849L11.051 21.9849Z",
    fill: "url(#paint3_linear_396_228)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2751 11.2656L19.1387 8.13281L22.1357 8.13281C23.1301 8.13281 23.8346 8.32928 24.4981 8.9923L26.6704 11.1652C28.4962 12.9771 28.5026 15.9356 26.6769 17.7475L25.8573 18.5647C25.8573 18.5647 25.8573 16.9215 25.8573 16.6891C25.8573 15.7224 25.5568 15.0308 25.2046 14.4605C24.8525 13.8902 23.2397 12.231 22.2751 11.2656Z",
    fill: "url(#paint4_linear_396_228)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.22 22.7591L20.3551 19.625V22.6198C20.3551 23.6135 20.1585 24.3175 19.495 24.9805L17.3204 27.1512C15.5072 28.9756 12.5466 28.9821 10.7334 27.1577L9.91553 26.3387C9.91553 26.3387 11.5599 26.3387 11.7925 26.3387C12.7599 26.3387 13.4521 26.0384 14.0228 25.6865C14.5935 25.3346 16.2539 23.723 17.22 22.7591Z",
    fill: "url(#paint5_linear_396_228)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76786 17.7044L8.9043 20.8372H5.90732C4.91289 20.8372 4.2084 20.6407 3.54489 19.9777L1.37256 17.8048C-0.453195 15.9928 -0.459675 13.0344 1.36608 11.2225L2.18568 10.4053C2.18568 10.4053 2.18568 12.0485 2.18568 12.2809C2.18568 13.2476 2.48621 13.9392 2.83835 14.5095C3.19048 15.0798 4.8033 16.739 5.76786 17.7044Z",
    fill: "url(#paint6_linear_396_228)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7869 6.2861L7.65186 9.42024L7.65186 6.42546C7.65186 5.43175 7.84846 4.72778 8.51198 4.06475L10.6865 1.89402C12.4997 0.0695973 15.4603 0.0631229 17.2736 1.88754L18.0914 2.70654C18.0914 2.70654 16.447 2.70654 16.2144 2.70654C15.247 2.70654 14.5549 3.00685 13.9842 3.35873C13.4135 3.71061 11.753 5.32224 10.7869 6.2861Z",
    fill: "url(#paint7_linear_396_228)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1973 20.7579V14.5851C55.1973 14.0613 55.3498 13.9569 55.7868 13.514L57.8604 11.4912C57.9007 11.4912 57.9344 11.5157 57.9344 11.5455V21.1359C57.9344 21.1657 57.9018 21.1902 57.8604 21.1902H55.7868C55.461 21.1902 55.1973 20.9964 55.1973 20.7579Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3717 20.6144V8.55938C63.3717 8.24104 63.6354 7.9834 63.9612 7.9834H66.1078V21.118C66.1078 21.1574 66.0751 21.1904 66.0337 21.1904H63.9601C63.6343 21.1904 63.3706 20.9328 63.3706 20.6144H63.3717Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M133.034 18.5454H126.262V8.01172H124.116C123.79 8.01172 123.526 8.26936 123.526 8.58769V20.6427C123.526 20.9568 123.785 21.2123 124.105 21.2177H124.115H126.261H133.032V18.5443L133.034 18.5454Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5751 8.0127H70.6476C70.3218 8.0127 70.0581 8.27034 70.0581 8.58867V10.1111C70.0581 10.4295 70.3218 10.6871 70.6476 10.6871H75.4486V20.6448C75.4486 20.9631 75.7123 21.2208 76.0381 21.2208H78.1847V10.6871H83.5751V8.01376V8.0127Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M98.557 8.0127C98.2312 8.0127 97.9675 8.27034 97.9675 8.58867V14.7903H89.9226V8.0127H87.776C87.4502 8.0127 87.1865 8.27034 87.1865 8.58867V20.6437C87.1865 20.9621 87.4502 21.2197 87.776 21.2197H89.9226V17.4636H97.9675V20.6437C97.9675 20.9621 98.2312 21.2197 98.557 21.2197H100.704V8.0127H98.557Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.081 17.1453C117.747 16.4916 118.925 14.9 118.925 13.0379V12.249C118.925 9.80456 116.897 7.82324 114.395 7.82324H106.517C106.191 7.82324 105.927 8.08089 105.927 8.39922V20.7087C105.927 20.9909 106.191 21.2198 106.517 21.2198H108.663V17.4637H112.87L115.658 20.9749C115.769 21.1154 115.941 21.1974 116.123 21.1974H119.296L116.079 17.1443L116.081 17.1453ZM108.663 10.454H114.018C115.185 10.454 116.132 11.3792 116.132 12.5194V12.7675C116.132 13.9077 115.185 14.8329 114.018 14.8329H108.663V10.454Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4045 7.95996C56.0406 7.95996 55.6908 8.10156 55.4326 8.35282L49.4101 14.2371C49.0799 14.5597 48.6866 14.6087 48.4806 14.6087C48.2747 14.6087 47.8824 14.5608 47.5512 14.2371L41.7521 8.57107C41.435 8.26126 41.1909 7.98232 40.8477 7.98232C40.5251 7.98232 40.1231 7.98445 39.6632 7.98658C39.2862 7.98871 39.0737 8.29746 39.0737 8.53061V9.48241V20.6474C39.0737 20.9455 39.3374 21.1883 39.6632 21.1883H41.7368C41.7771 21.1883 41.8109 21.1584 41.8109 21.1212V12.4294L45.6072 16.1386C46.3983 16.9115 47.44 17.297 48.4817 17.297C49.5234 17.297 50.5662 16.9105 51.3562 16.1386L57.735 9.90614C57.8614 9.78264 57.9322 9.61549 57.9322 9.44089V7.96103H56.4034L56.4045 7.95996Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_396_228",
    x1: 5.08089,
    y1: 3.79398,
    x2: 5.08089,
    y2: 16.6165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F62584"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4009A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_396_228",
    x1: 24.7195,
    y1: 5.55909,
    x2: 11.8876,
    y2: 5.55909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F62584"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4009A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_396_228",
    x1: 22.9494,
    y1: 25.1562,
    x2: 22.9494,
    y2: 12.3337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F62584"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4009A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_396_228",
    x1: 3.31859,
    y1: 23.3989,
    x2: 16.1505,
    y2: 23.3989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F62584"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4009A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_396_228",
    x1: 29.6638,
    y1: 15.6893,
    x2: 20.7349,
    y2: 7.54224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB22FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6316BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_396_228",
    x1: 12.7931,
    y1: 30.1424,
    x2: 20.933,
    y2: 21.2081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB22FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6316BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_396_228",
    x1: -1.62082,
    y1: 13.2807,
    x2: 7.30812,
    y2: 21.4277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB22FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6316BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_396_228",
    x1: 15.2139,
    y1: -1.09717,
    x2: 7.07389,
    y2: 7.83711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB22FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6316BE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f05a1fe52c1210e1ae20e5a700ce0295.svg";
export { ForwardRef as ReactComponent };